import React, { useCallback } from 'react'
import classNames from 'classnames'

import { ReportNode } from '@/apollo/graphql'
import { IReport } from '@/types'

import { useData } from '../useData'
import ReportForm from './form'

interface IEditReport {
  visible: boolean
  node?: Partial<ReportNode>
  onClose: () => void
}

const EditReport: React.FC<IEditReport> = ({ visible, onClose, node }) => {
  const { loading, submitting, onSubmit } = useData({ id: node?.id })

  const onSubmitForm = useCallback(
    (d: IReport) => {
      delete d.driver
      delete d.customer
      delete d.deal

      onSubmit(`reports/${node?.id}/`, true, onClose)(d)
    },
    [node?.id, onSubmit, onClose],
  )
  return (
    <div
      className={classNames('info-box mobile-modal scroll-sticky w-100', {
        open: visible,
      })}
    >
      <ReportForm
        loading={loading}
        isEditing={visible}
        initialData={node}
        onCancel={onClose}
        submitting={submitting}
        onSubmit={onSubmitForm}
      />
    </div>
  )
}

export default EditReport
